import FYBXD from '../../../../components/reimbursement/fybxd'
import saleBill from '../../../../components/reimbursement/saleBill'
import saleFybxd from '../../../../components/reimbursement/saleFybxd'
import publicBuill from '../../../../components/reimbursement/js/publicBuill'

export default {
  components: {
    FYBXD,
    saleFybxd,
    saleBill
  },
  data() {
    return {
      billTemplate: {
        rowData: {},
        view: 'view',
        FYShow: false,
        saleBillShow: false,
        saleFybxdShow: false
      },
      // 查询参数
      queryParams: {
        currentPage: 1,
        pageSize: 200,
        djh: undefined,
        jkr: undefined,
        lbmc: '全部',
        billcode: '未生成凭证'
      },
      // 显示搜索条件
      showSearch: true,
      /* 单据类别 */
      statusOptions: [
        {
          dictLabel: '全部',
          dictValue: '全部'
        }, {
          dictLabel: '费用报销单',
          dictValue: '费用报销单'
        }, {
          dictLabel: '销售费用报销单',
          dictValue: '销售费用报销单'
        }, {
          dictLabel: '销售出差报销单',
          dictValue: '销售出差报销单'
        }
      ],
      /* 凭证标识 */
      statuspzh: [
        {
          dictLabel: '全部',
          dictValue: '全部'

        }, {
          dictLabel: '未生成凭证',
          dictValue: '未生成凭证'
        }, {
          dictLabel: '已生成凭证',
          dictValue: '已生成凭证'
        }
      ],
      /* table字段 */
      randomKey: Math.random(),
      total: 0,
      tableData: [],
      /* 组件标识 */
      rowData: {},
      FYShow: false,
      /* */
      tableHeight: window.innerHeight - 235,
      ids: ''
    }
  },
  mounted() {
    this.getList()

  },
  created() {
    publicBuill.setThis(this)
  },
  methods: {
    /*搜索*/
    handleQuery() {
      this.queryParams.currentPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.$refs['queryForm'].resetFields()
      this.handleQuery()
    },
    /* 查看页面 */
    async view(index, row) {
      this.billTemplate.rowData = await publicBuill.findBillDataByBillCode(row.djh, row.lrr)
      if (row.djh.indexOf('FY') !== -1) {
        this.billTemplate.FYShow = true
      } else if (row.djh.indexOf('CB') !== -1) {
        this.billTemplate.saleBillShow = true
      } else if (row.djh.indexOf('FB') !== -1) {
        this.billTemplate.saleFybxdShow = true
      }
    },
    getList() {
      const data = {
        lbmc: this.queryParams.lbmc,
        billcode: this.queryParams.billcode,
        djh: this.queryParams.djh ? this.queryParams.djh : null,
        jkr: this.queryParams.jkr ? this.queryParams.jkr : null,
        currentPage: this.queryParams.currentPage,
        limit: this.queryParams.pageSize
      }
      this.$post('/fesback/Financial/documentList.z', data).then(request => {
        this.tableData = request.data.data
        this.total = request.data.count
        this.$message({
          message: request.message,
          type: 'success'
        })
      })

    },
    // 生成凭证操作
    voucherAdd(row) {
      if (this.ids.length === 0) {
        this.$message.error('请至少勾选一条单据信息')
        return false
      }
      const jkr = Array.from(new Set(this.jkr))
      if (jkr.length > 1) {
        this.$message.error('借款人或供应商信息不一致')
        return false
      }
      const djh = row.djh || this.ids
      const djhs = djh.join(',')
      const _this = this
      this.$confirm('是否生成凭证?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        const loading = _this.$loading({
          lock: true,
          text: '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        _this.$post('/fesback/voucher/voucherAdd.z?djhs=' + djhs + '&confirm=' + 1).then(request => {
          loading.close()
          _this.getList()
          if (request.code === '500') {
            _this.$message.error(request.message + '/' + request.data.messages[0])
          } else {
            _this.$message({
              type: 'success',
              message: request.message
            })
          }
        })
      })
    },
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.getList()
    },
    /* table */
    handleCurrentChange(val) {
      this.currentRow = val
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    rowClick(row, event, column) {
      this.rowClickIndex = row.index
    },
    editData(row, column) {
      row[column.property + 'isShow'] = true
      //refreshTable是table数据改动时，刷新table的
      this.refreshTable()
      this.$nextTick(() => {
        // this.$refs[column.property] && this.$refs[column.property].focus()
      })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.djh)
      this.jkr = selection.map(item => item.jkr)
    },
    dateFormat(row, column) {
      const date = new Date(row.rq)
      let d = date.getFullYear() + '-'
      if ((date.getMonth() + 1) < 10) {
        d += '0' + (date.getMonth() + 1)
      } else {
        d += (date.getMonth() + 1)
      }
      d += '-'
      if (date.getDate() < 10) {
        d += '0' + date.getDate()
      } else {
        d += date.getDate()
      }
      return d
    }

  }

}
